/** Une clases condicionales sin dependencias externas (misma forma que `apps/admin/src/lib/cn.ts`). */
export function cn(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ');
}
